/* tslint:disable */
/* eslint-disable */
/**
 * True one Services API
 * True one service for form Builder
 *
 * The version of the OpenAPI document: 4.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface ShiftPattern
 */
export interface ShiftPattern {
    /**
     * 
     */
    shiftsPerDay?: number;
    /**
     * 
     */
    shiftDurationHours?: number;
    /**
     * 
     */
    firstShiftStart?: string;
}

/**
 * Check if a given object implements the ShiftPattern interface.
 */
export function instanceOfShiftPattern(value: object): value is ShiftPattern {
    return true;
}

export function ShiftPatternFromJSON(json: any): ShiftPattern {
    return ShiftPatternFromJSONTyped(json, false);
}

export function ShiftPatternFromJSONTyped(json: any, ignoreDiscriminator: boolean): ShiftPattern {
    if (json == null) {
        return json;
    }
    return {
        
        'shiftsPerDay': json['shiftsPerDay'] == null ? undefined : json['shiftsPerDay'],
        'shiftDurationHours': json['shiftDurationHours'] == null ? undefined : json['shiftDurationHours'],
        'firstShiftStart': json['firstShiftStart'] == null ? undefined : json['firstShiftStart'],
    };
}

export function ShiftPatternToJSON(json: any): ShiftPattern {
    return ShiftPatternToJSONTyped(json, false);
}

export function ShiftPatternToJSONTyped(value?: ShiftPattern | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'shiftsPerDay': value['shiftsPerDay'],
        'shiftDurationHours': value['shiftDurationHours'],
        'firstShiftStart': value['firstShiftStart'],
    };
}

